import useGlobalStore from '@/stores/global.store';
import { useQuery } from '@tanstack/react-query';
import api from '../../api';
import { type Payment } from '../../types/api/payment';

type PaymentQueryKey = ['payments', string];

export function usePaymentQuery(paymentId: string) {
  return useQuery<Payment, Error, Payment, PaymentQueryKey>({
    queryKey: ['payments', paymentId],
    queryFn: () => api.payment.get(paymentId),
    enabled: Boolean(paymentId),
  });
}

export function useCurrentPaymentQuery() {
  const paymentId = useGlobalStore((state) => state.paymentId);

  return usePaymentQuery(paymentId!);
}
